<template>
  <div class="cm-img">
    <img :src="pathImg" />
  </div>
</template>
<script setup>
const props = defineProps({
  name: {
    type: String,
    default: ''
  }
})
const pathImg = ref()
onMounted(() => {
  pathImg.value = new URL(
    `../../assets/image/${window.__themeEnv}/${props.name}.png`,
    import.meta.url
  ).href
})
</script>
<style lang="scss" scoped>
.cm-img {
  img {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
